import { ACTION_SUBJECT_PREFIX } from '../../constants/analytics';
import { type FireAnalyticsEvent } from '../../types';

import { type CommonAttributes, type NonPrivacySafeAttributes } from './types';

/** rendered searchPageRightPanelAppFilter */
export const onAppFilterRendered = ({
	commonAttributes,
	nonPrivacySafeAttributes,
	numOfFilters,
	numOfUnconnectedApps,
	viewportHeight,
	viewportWidth,
}: {
	commonAttributes: CommonAttributes;
	nonPrivacySafeAttributes: NonPrivacySafeAttributes;
	numOfFilters: number;
	numOfUnconnectedApps: number;
	viewportHeight?: number;
	viewportWidth?: number;
}): FireAnalyticsEvent => ({
	eventType: 'ui',
	actionSubject: 'filter',
	actionSubjectId: `${ACTION_SUBJECT_PREFIX}RightPanelAppFilter`,
	action: 'rendered',
	attributes: {
		additionalAttributes: {
			numOfFilters,
			numOfUnconnectedApps,
			...(viewportHeight !== undefined && { viewportHeight }),
			...(viewportWidth !== undefined && { viewportWidth }),
		},
		commonAttributes,
	},
	nonPrivacySafeAttributes,
});
